import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  // deleteTravallerInfo,
  getAllUsersM,
  getUserMRecentBookings,
  getUserMById,
  updateUserM,
  getCustomerDetailFromMobileNo,
} from "./services/userManagement.services";
import { IUserM, IUserMState } from "./userManagementModel";

const initialState: IUserMState = {
  loading: false,
  formloading: false,
  error: "",
  UserMList: [],
  UserMRecentBookings: [],
  UserMID: null,
  TravelerInfoDeleteIndex: -1,
  UserMDetails: {
    Id: null,
    user_guid: "",
    first_name: "",
    last_name: "",
    date_of_birth: "",
    gender: null,

    nationality_name: "",
    nationality_code: "",
    country_name: "",
    country_code: "",
    state_name: "",
    state_code: "",
    city_name: "",

    profile_photo: "",
    is_email_verified: false,
    billing_address: "",

    billing_country_name: "",
    billing_country_code: "",
    billing_state_name: "",
    billing_state_code: "",
    billing_city_name: "",

    billing_pan_card_no: "",
    billing_gst_reg_name: "",
    billing_pan_card_name: "",
    billing_pincode: "",
    billing_gst_no: "",
    TravellersInformationList: [],
    isactive: 1,
  },
  FilterWebsiteUsers: {
    first_name: "",
    last_name: "",
    mobile_no: "",
    email_id: "",
    city_name: "",
  },
};

const userMSlice = createSlice({
  name: "userM",
  initialState,
  reducers: {
    clearUserMDetails: (state) => {
      state.UserMDetails = initialState.UserMDetails;
    },
    setTravelerInfoDeleteIndex: (state, action) => {
      state.TravelerInfoDeleteIndex = action.payload;
    },
    setUserMID: (state, action) => {
      state.UserMID = action.payload;
    },
    clearUserMID: (state) => {
      state.UserMID = initialState.UserMID;
    },
    setFilterWebsiteUsers: (state, action) => {
      state.FilterWebsiteUsers = action.payload;
    },
    clearFilterWebsiteUsers: (state) => {
      state.FilterWebsiteUsers = initialState.FilterWebsiteUsers;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllUsersM.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getAllUsersM.fulfilled,
      (state, action: PayloadAction<IUserM[]>) => {
        state.loading = false;
        state.UserMList = action.payload || [];
        state.error = "";
      }
    );
    builder.addCase(getAllUsersM.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.UserMList = [];
    });
    builder.addCase(getUserMRecentBookings.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getUserMRecentBookings.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.UserMRecentBookings = action.payload || [];
        state.error = "";
      }
    );
    builder.addCase(getUserMRecentBookings.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.UserMRecentBookings = [];
    });
    /* FindByIdUserTravellerBilling */
    builder.addCase(getUserMById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUserMById.fulfilled, (state, action) => {
      state.loading = false;
      state.UserMDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getUserMById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.UserMDetails = initialState.UserMDetails;
    });
    builder.addCase(updateUserM.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateUserM.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateUserM.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getCustomerDetailFromMobileNo.pending, (state) => {
      state.formloading = true;
    });
    builder.addCase(getCustomerDetailFromMobileNo.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(getCustomerDetailFromMobileNo.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});
export const {
  setFilterWebsiteUsers,
  clearFilterWebsiteUsers,
  setUserMID,
  clearUserMID,
  clearUserMDetails,
  setTravelerInfoDeleteIndex,
} = userMSlice.actions;
export default userMSlice.reducer;
